import React from 'react'
import { prop } from 'ramda'

import * as API from '~/constants/api'
import MultiSelectSearchField from '~/components/Fields/MultiSelectSearchField'

const getOptionLabel = item => {
  if (item) {
    return prop('name', item)
  }

  return ''
}

const getOptionValue = item => {
  if (item) {
    const id = prop('id', item)
    const guid = prop('guid', item)
    const firstName = prop('firstName', item)
    const lastName = prop('lastName', item)
    const name = `${firstName} ${lastName}`

    return { id, guid, name }
  }

  return null
}

function ReturnCustomerField (props) {
  return (
    <MultiSelectSearchField
      name="customers"
      label="Customer"
      api={API.SALE_ORDER_CUSTOMER}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      {...props}
    />
  )
}

export default ReturnCustomerField
